import ChartBlock from "./ChartBlock";
import MarkdownContent from "./MarkdownContent";
import MessageActionButtons from "./MessageActionButtons";
import { parseAssistantContent, type ParsedAssistantContent } from "./utils";

type AssistantContentProps = {
  content: string;
  parsedContent?: ParsedAssistantContent;
  isStreaming?: boolean;
  actionsMode?: "interactive" | "hidden";
  onAction?: (action: string) => void;
};

export default function AssistantContent({
  content,
  parsedContent,
  isStreaming = false,
  actionsMode = "interactive",
  onAction,
}: AssistantContentProps) {
  const { text, chart, actions } = parsedContent ?? parseAssistantContent(content);

  return (
    <>
      <MarkdownContent content={text} isStreaming={isStreaming} />
      {!isStreaming && chart && <ChartBlock spec={chart} />}
      {!isStreaming && actionsMode === "interactive" && (
        <MessageActionButtons actions={actions} onAction={onAction} />
      )}
    </>
  );
}
